import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {UserLoginService} from "../../../service/user-login.service";
import {CognitoCallback} from "../../../service/cognito-util.service";
import { MatDialog, MatDialogRef} from '@angular/material';
import { ForgotPasswordStep1DialogComponent } from './forgotPasswordStep1Dialog.component';
const scheduleMicrotask = Promise.resolve(null);

@Component({
    selector: 'forgotPasswordStep1-app',
    templateUrl: './forgotPasswordStep1.html'
})
export class ForgotPasswordStep1Component implements CognitoCallback {
    email: string;
    errorMessage: string;

    constructor(public router: Router,
                public userService: UserLoginService,
                public dialog: MatDialog) {
        this.errorMessage = null;
    }
    ngOnInit() {
        scheduleMicrotask.then(() => {
            this.openDialog();
          });
    }

    cognitoCallback(message: string, result: any) {
        if (message == null && result == null) { // verification code
            this.router.navigate(['/unohtunutSalasana', this.email]);
        } else {  // error
            this.errorMessage = message;
            this.openDialog();
        }
    }

    openDialog() {
        
        let dialogRef = this.dialog.open(ForgotPasswordStep1DialogComponent, {
            data: {errorMessage: this.errorMessage},
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result){
            this.email = result;
            console.log('this.email:'+this.email);
            this.errorMessage = null;
            this.userService.forgotPassword(this.email, this);
          }
          else {
            this.router.navigate(['/etusivu']);
          }
        });
      }
    }








// WEBPACK FOOTER //
// ./src/app/public/auth/forgot/forgotPasswordStep1.component.ts